<template>
  <div>
    <NavBtns></NavBtns>

    <!--標題-->
    <section id="conta1">
      <div class="blackbox">
        <div class="text">{{ $t('message.nav_contact') }}</div>
      </div>
    </section>

    <!--聯絡方式-->
    <section id="conta2">
      <div class="container">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-6">
            <div class="line">
              <img
                class="img-fluid"
                src="../assets/images/contact_line.svg"
                alt="line@"
              />
              <!-- <div class="contatext wow">
								<a href="https://line.me/R/ti/p/%40dqt5211c">@owlocker</a>
								<a class="page-scroll" href="#conta3">
									<div class="button">{{ $t("message.ct_lineat_watch_teaching") }}</div>
								</a>
							</div> -->
              <div class="contatext wow">
                <a href="https://line.me/R/ti/p/%40dqt5211c">@owlocker</a>
                <span>
                  <i class="fas fa-arrow-alt-circle-down"></i>
                  <a class="page-scroll" href="#conta3">{{
                    $t('message.ct_lineat_watch_teaching')
                  }}</a>
                </span>
                <a href="https://line.me/R/ti/p/%40dqt5211c"
                  ><div class="button">
                    {{ $t('message.ct_lineat_join_bt') }}
                  </div></a
                >
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6">
            <div class="mobile">
              <img
                class="img-fluid"
                src="../assets/images/contact_mobile.svg"
                alt="手機"
              />
              <div class="contatext wow">
                <a href="tel:0982058368">0982 - 058368</a>
                <a href="tel:0982058368">
                  <div class="button">{{ $t('message.ct_call') }}</div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6">
            <div class="phone">
              <img
                class="img-fluid"
                src="../assets/images/contact_phone.svg"
                alt="電話"
              />
              <div class="contatext wow">
                <a href="tel:04-24211520">04 - 24211520</a>
                <a href="tel:04-24211520">
                  <div class="button">{{ $t('message.ct_call') }}</div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6">
            <div class="mail">
              <img
                class="img-fluid"
                src="../assets/images/contact_email.svg"
                alt="信箱,e-mail"
              />
              <div class="contatext wow">
                <a href="mailto:gzlockers@gmail.com">gzlockers@gmail.com</a>
                <a href="mailto:gzlockers@gmail.com">
                  <div class="button">{{ $t('message.ct_send_mail') }}</div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-lg-12 col-md-12">
            <div class="location">
              <img
                class="img-fluid"
                src="../assets/images/contact_location.svg"
                alt="地址"
              />
              <div class="contatext wow">
                <a
                  href="https://goo.gl/maps/UapgrK297u32"
                  target="_blank"
                  v-html="$t('message.ct_address')"
                ></a>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </section>

    <!--line @-->
    <section id="conta3">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="blackbox">
              <img
                class="img-fluid"
                src="../assets/images/feature_e04.svg"
                alt="line@"
              />
              <span>{{ $t('message.ct_teach') }}</span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="lineimg">
              <img
                class="img-fluid"
                src="../assets/images/contact_line.svg"
                alt="line@"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="title">
              {{ $t('message.ct_lineat_join') }}
              <div class="content">
                {{ $t('message.ct_lineat_join_way1') }}
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox">
                      <img
                        class="img-fluid"
                        src="../assets/images/contact_a01.png"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way11') }}</p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox">
                      <img
                        class="img-fluid"
                        src="../assets/images/contact_a02.png"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way12') }}</p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox">
                      <img
                        class="img-fluid"
                        src="../assets/images/contact_a03.png"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way13') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content2">
                {{ $t('message.ct_lineat_join_way2') }}
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox">
                      <img
                        class="img-fluid"
                        src="../assets/images/contact_a01.png"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way21') }}</p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox">
                      <img
                        class="img-fluid"
                        src="../assets/images/contact_a04.png"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way22') }}</p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="imgbox2">
                      <img
                        class="img-fluid"
                        src="../assets/images/line_qrcode.svg"
                        alt="搜尋ID：@owlocker"
                      />
                      <p>{{ $t('message.ct_lineat_join_way23') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="oneimg">
              <img
                class="img-fluid"
                src="../assets/images/contact_a05.png"
                alt="line@"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { WOW } from 'wowjs';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';

export default {
  name: 'Contact',
  components: {
    NavBtns,
    GzFooter,
  },
  computed: {
    //網路連線狀態
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  mounted: function () {
    //動畫處理
    new WOW().init();
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得合作廠商
      this.vLoadPartners();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
  },
  watch: {
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
